export enum DeleteAccountErrorKind {
  RequiresRecentLogin = 'requires-recent-login',
  NoUser = 'no-user',
  Unknown = 'unknown',
}

export class DeleteAccountError extends Error {
  constructor(public readonly kind: DeleteAccountErrorKind) {
    super(`Delete account failed: ${kind}`);
    this.name = 'DeleteAccountError';
  }
}
